export default {
  itemCount: {
    one: '{{count}} Item in Your Cart',
    other: '{{count}} Items in Your Cart',
  },
  startCheckoutButton: {
    text: 'Proceed to Checkout',
  },
  orderSummary: {
    title: 'Order Summary',
  },
  freeShippingThresholds: {
    thresholdMet: "You're getting free standard shipping on orders from {{shopName}}!",
    amountRemaining: "You're {{amountRemainingDisplay}} away from getting free standard shipping from {{tagOpen}}{{shopName}}{{tagClose}}</a>.",
  },
  cartItemQuantitySelect: 'Quantity',
  cartItemPricing: {
    priceDisplay: {
      one: '{{priceDisplay}}',
      other: '{{count}}x {{priceDisplay}}',
    },
    priceDescription: {
      one: '{{priceDisplay}}',
      other: '{{count}} at {{priceDisplay}}',
    },
  },
  buyWithAffirmDefaultText: 'Buy with monthly payments through Affirm',
  buyNowPayOverTime: 'Buy now, pay over time with Affirm',
  makeMonthlyPayments: 'Make monthly payments with no hidden fees',
  splitPay: 'Make regular payments with no hidden fees',
  removeItem: 'Remove Item',
  moveToWatchList: 'Move to Watch List',
  acceptedOffer: 'Accepted Offer',
};
